module.exports = __webpack_public_path__ + "img/acc3.1cd71e6e.png";